import merge from 'lodash/merge';
import { useMemo, useEffect } from 'react';
// @mui
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
//
import { useSettingsContext } from './SettingsContext';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function ThemeContrast({ children }: Props) {
  const outerTheme = useTheme();

  const { themeContrast, themeMode } = useSettingsContext();

  const isLight = themeMode === 'light';

  const isContrastBold = themeContrast === 'bold';

  useEffect(() => {
    if (themeContrast === 'bold') {
      document.documentElement.setAttribute('data-theme', 'bold');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    // eslint-disable-line
  }, [themeContrast]);

  const themeOptions = useMemo(
    () => ({
      palette: {
        background: {
          ...(themeContrast === 'bold' && {
            default: isLight ? outerTheme.palette.grey[100] : outerTheme.palette.grey[900],
          }),
        },
      },
      components: {
        MuiCard: {
          styleOverrides: {
            ...(isContrastBold && {
              root: {
                boxShadow: outerTheme.customShadows.z4,
              },
            }),
          },
        },
      },
    }),
    // eslint-disable-line
    [isLight, themeContrast],
  );

  const theme = createTheme(merge(outerTheme, themeOptions));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
